<template>
  <div class="vld-parent">
    <loading :active.sync="isLoading" :is-full-page="true" />

    <div class="mt-8 text-center">
      <div
        class="flex flex-col items-center px-8 mx-auto mb-6 lg:px-20 lg:justify-center md:flex-row lg:space-x-10"
      >
        <div>
          <img
            v-if="drop.imageURL"
            :src="drop.imageURL"
            class="object-contain h-72"
            alt="Product Image"
          />
          <img
            v-if="drop.actualImageURL"
            :src="drop.actualImageURL"
            class="object-contain h-72"
            alt="Product Image"
          />
        </div>
        <div class="text-left">
          <h1 class="mt-2 text-2xl font-semibold">{{ drop.name }}</h1>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Hotness:</span>
            {{ drop.hotness || 'N/A' }}
          </p>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black"
              >{{
                drop.type === 'walmart' ? 'UPC' : drop.type === 'target' ? 'DPCI' : 'Product No'
              }}:</span
            >
            {{ drop.upc }}
          </p>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Actual UPC:</span> {{ drop.actualUPC }}
          </p>
          <a
            target="_blank"
            :href="'http://barcode.live/?upc=' + drop.actualUPC"
            class="mt-2 text-lg font-semibold text-blue-500"
          >
            See Barcode
          </a>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Price:</span> ${{ drop.price }}
          </p>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Quantity:</span>
            {{ drop.quantity != 0 ? drop.quantity : 'Unknown' }}
          </p>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Status:</span> {{ drop.status }}
          </p>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Alert Time:</span>
            {{
              new Date(drop.createdAt).toLocaleString(
                {},
                { dateStyle: 'medium', timeStyle: 'short' },
              )
            }}
          </p>
          <p
            class="mt-2 text-lg"
            :class="{
              'text-blue-600': drop.type === 'walmart',
              'text-red-600': drop.type === 'target',
            }"
          >
            {{ drop.type.toUpperCase() }}
          </p>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Store:</span> {{ drop.store }}
          </p>
          <p class="flex flex-col mt-2 text-lg text-gray-800 lg:flex-row">
            <span class="font-semibold text-black">Address:</span>
            <a
              :href="'https://maps.google.com/maps?q=' + drop.address"
              alt="Store Google Maps Link"
              target="_blank"
              class="text-blue-500"
              >{{ drop.address }}
            </a>
          </p>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Department:</span>
            {{ drop.department || 'N/A' }}
          </p>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Where to Find:</span>
            {{ drop.whereToFind || 'N/A' }}
          </p>
          <p class="mt-2 text-lg text-gray-800">
            <span class="font-semibold text-black">Comment/Tip:</span>
            {{ drop.comment || 'N/A' }}
          </p>
          <div v-if="drop.type === 'walmart'">
            <p class="mt-2 text-lg text-gray-800" v-if="updatedStatus">
              <span class="font-semibold text-black">Updated Status:</span> {{ updatedStatus }}
            </p>
            <t-button variant="success" class="mt-2 text-lg" @click="handleStatusCheck">
              Check Status
            </t-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GET_DROP from '@/graphql/GetDropById';

export default {
  name: 'DropDetail',
  data() {
    return {
      isLoading: false,
      drop: {},
      updatedStatus: '',
    };
  },
  async created() {
    this.isLoading = true;
    const {
      params: { id },
    } = this.$route;
    try {
      const {
        data: { DropById },
      } = await this.$apollo.query({
        query: GET_DROP,
        variables: { id },
      });
      const { product, ...rest } = DropById;
      const {
        imageURL,
        hotness,
        whereToFind,
        department,
        actualImageURL,
        actualUPC,
        comment,
      } = product;
      this.drop = {
        ...rest,
        imageURL,
        hotness,
        whereToFind,
        department,
        actualImageURL,
        actualUPC,
        comment,
      };
    } catch (e) {
      console.log(e);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    handleStatusCheck() {
      const url = `https://search.mobile.walmart.com/v1/products-by-code/UPC/${this.drop.upc}?storeId=${this.drop.store}`;
      this.isLoading = true;
      fetch(url)
        .then((response) => response.json())
        .then((json) => {
          const { data } = json;
          const {
            inStore: { inventory },
          } = data;
          if (inventory && inventory.status) {
            this.updatedStatus = inventory.status;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
